/**
=========================================================
* Soft UI Dashboard PRO React - v4.0.1
=========================================================

* Product Page: https://www.creative-tim.com/product/soft-ui-dashboard-pro-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/
import SoftBox from "components/SoftBox";
import SoftButton from "components/SoftButton";
import { useQueryClient } from "@tanstack/react-query";
import { useParams } from "react-router-dom";
import { useProductLocations, useCreateAccountManually } from "queries/saas";

export default function dataTableData() {
  const queryClient = useQueryClient();
  const { product_id } = useParams()

  const { data: productLocationsResponse, isLoading: loader } = useProductLocations(product_id);
  const List = productLocationsResponse?.data || [];

  const onLoad = () => {
    queryClient.invalidateQueries({ queryKey: ["saas-product-locations"] });
  };
  const { mutateAsync: createAccountManually } = useCreateAccountManually();
  const handleCreateAccount = async (data) => {
    const { response } = await createAccountManually(data);
    if (response) onLoad();
  };

  return {
    loader: loader,
    handleRefresh: onLoad,
    dataTableData: {
      columns: [
        { Header: "Name", accessor: "name" },
        { Header: "Email", accessor: "email" },
        { Header: "price_id", accessor: "price_id" },
        { Header: "subscription_id", accessor: "subscription_id" },
        { Header: "Action", accessor: "action" },
      ],

      rows: List.map((data) => ({
        name: data.name,
        email: data.email,
        price_id: data.price_id,
        subscription_id: data.subscription_id,
        // business_name: data.business_name,
        action: (
          <SoftBox>
            {
              data?.account_created == true ?
                <SoftButton
                  variant="contained"
                  color="dark"
                  size="small"
                  sx={{ marginLeft: 2 }}
                >
                  Created
                </SoftButton>
                :
                <SoftButton
                  variant="contained"
                  color="info"
                  size="small"
                  sx={{ marginLeft: 2 }}
                  onClick={() => handleCreateAccount(data)}
                >
                  Create Account
                </SoftButton>
            }

          </SoftBox>
        ),
      })),
    },
  };
}
